export default __webpack_public_path__ + "static/media/1011.4714fadd.png";